import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import content from "@/data/content.json";
import { AccentH2, Container, CtaButton, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { ablauf, meta } = content;

export const Ablauf = () => (
  <Section id="ablauf" testId="section-ablauf" className="has-lines overflow-hidden bg-[#f5f6f4]">
    <FlowLines color="#0F9D6E" opacity={[0.055, 0.045]} />
    <Container>
      <Reveal>
        <Label>{ablauf.label}</Label>
        <AccentH2 className="mt-6 font-bold text-[#1e2532]">{ablauf.h2}</AccentH2>
      </Reveal>

      <div className="relative mt-14">
        <span className="absolute left-0 right-0 top-7 hidden h-px bg-[#c9cdc9] md:block" aria-hidden="true" />
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-7">
          {ablauf.steps.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.1}>
              <div data-testid={`ablauf-step-${i}`} className="step-card group relative flex h-full flex-col">
                <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-[#0f9d6e]/30 bg-white font-display text-[17px] font-bold text-[#0b7d57]">
                  {s.num}
                </span>
                <div className="mt-6 flex-1 rounded-[16px] border border-[#dfe2e0] bg-white p-7 md:p-8">
                  <h3 className="font-semibold text-[#1e2532]">{s.h3}</h3>
                  <span className="accent-rule mt-3" aria-hidden="true" />
                  <p className="mt-4 text-[16px] leading-[1.76] text-[#565f70]">{s.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.1}>
        <div
          data-testid="cta-band"
          className="has-lines mt-16 flex flex-col items-start justify-between gap-8 overflow-hidden rounded-[18px] bg-[#1e2532] p-9 md:flex-row md:items-center md:p-12"
        >
          <FlowLines />
          <div>
            <p className="max-w-[560px] font-display text-[21px] font-medium leading-[1.42] text-white md:text-[26px]">
              {ablauf.ctaText}
            </p>
            <a
              href={meta.phoneHref}
              className="mt-5 inline-flex items-center gap-2.5 text-[15px] font-semibold text-[#3ecf9b]"
            >
              <Phone size={16} />
              <span className="link-underline">Oder direkt anrufen: {meta.phone}</span>
            </a>
          </div>
          <div className="flex items-center gap-4">
            <CtaButton testId="cta-band-button">{ablauf.ctaButton}</CtaButton>
            <ArrowRight size={20} className="hidden text-[#3ecf9b] md:block" />
          </div>
        </div>
      </Reveal>
    </Container>
  </Section>
);
